import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'mobility-instore-merch',
  footer: 'mobility-instore-merch',
}

const pageBrand: PageBrand = 'consumer'

export const mobInStore = new LineOfBusinessConfig(geConfig, pageBrand)
